import { render, staticRenderFns } from "./AppListMobile.vue?vue&type=template&id=650e8ea0&scoped=true"
import script from "./AppListMobile.vue?vue&type=script&lang=js"
export * from "./AppListMobile.vue?vue&type=script&lang=js"
import style0 from "./AppListMobile.vue?vue&type=style&index=0&id=650e8ea0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e8ea0",
  null
  
)

export default component.exports